import script from "./AboutView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutView.vue?vue&type=script&lang=ts&setup=true"

import "./AboutView.vue?vue&type=style&index=0&id=14ae42f4&lang=scss"

const __exports__ = script;

export default __exports__